import { memo } from 'react';

import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { useStyles } from './style';

interface Props {
  text?: string;
}

const Error: React.FC<Props> = ({ text = 'Jotain meni pieleen' }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <InfoOutlinedIcon className={classes.icon} />
      <span>{text}</span>
    </div>
  );
};

export default memo(Error);
